export enum CommunicationStatus {
  none = 1,
  some = 2,
  all = 3
}